import { get, isEmpty } from 'lodash'

const transformToUpdateDishTypeImageDetailsArgs = data => ({
  image: isEmpty(data.image)
    ? null
    : get(data, 'image[0].originFileObj', undefined),
  processedImage: isEmpty(data.processedImage)
    ? null
    : get(data, 'processedImage[0].originFileObj', undefined),
  icon: isEmpty(data.icon)
    ? null
    : get(data, 'icon[0].originFileObj', undefined),
})

export default transformToUpdateDishTypeImageDetailsArgs
